export const ALERT_SHOW_MESSAGE = "ALERT_SHOW_MESSAGE";
export const ALERT_HIDE = "ALERT_HIDE";

export const showMsg =
  (message, message2 = undefined) =>
  (dispatch) => {
    dispatch({
      type: ALERT_SHOW_MESSAGE,
      message: message,
      message2: message2,
    });
  };
export const hideMsg = () => (dispatch) => {
  dispatch({
    type: ALERT_HIDE,
  });
};
